import { css } from 'emotion';

export const loader = css`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  background: rgba(255, 255, 255, 0.6);
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const activityChat = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
`;
